//JSUnusedGlobalSymbols, JSUnusedLocalSymbols
/**
 * ESA Component: Live Content Controller
 * -------------------------------------------------------------
 * @copyright {{PKG_COPYRIGHT}}
 * @license   {{PKG_LICENSE}}
 * @version   {{PKG_VERSION}}, {{PKG_DATE}}
 */

import Controller from "@phmg/com_hive/src/js/exports/Controller.js"
import IntervalHandler from "@phmg/com_hive/src/js/exports/IntervalHandler.js"
import {v4 as UUIDv4} from 'uuid';
import StatusHandler from "@phmg/com_hive/src/js/exports/StatusHandler.js";

class LiveEventController extends Controller {
  /** Controller ID */
  static CID = "event.live";
  /** Controller name */
  static NAME = "Live Event"

  /** Process ID (UUID) */
  PID;

  Display;
  Player;
  iFrame;

  State;
  // 0 = idle, 1 = playing, -1 = paused, -2 = ended
  PlayingState = 0;
  PausedBySystem = 0;

  Records;
  RecordId = 0;
  ContentKey = '';
  ContentType = "vimeo.live"

  Calling = false;
  Logging = false;
  Checking = false;
  Sleeping = false;
  READY = { Player : false, Record : false, State : false };

  LogQueue = [];
  LogDate = 0;
  LogData;

  Options = {
    logEnabled      : true,
    logInterval     : 48,
    logQueueTimeout : 1,
    noLogTimeout    : 120,
  }


  // Handlers
  CallHandler;
  SH;
  IH;
  loadingDisplay;

  // Selectors
  DISPLAY_SELECTOR = "#liveDisplay";

  /**
   * Fires on "DOMContentLoaded" event
   */
  initiate() {
    super.initiate();

    // Check if display container is present.
    // If not it means there's no video / stream to track, and we can bail
    this.Display = document.querySelector(this.DISPLAY_SELECTOR);
    if (!this.Display) {
      this.utils.odb("No display.", this);
      return;
    }

    this.loadingDisplay = Hive.getLoadingDisplay();

    // Validate our context / build the request
    let validData = this.validateContext();
    if (!validData) return;

    // Add loading display
    this.onLoad();

    // Set process UUID
    this.PID = UUIDv4();
    validData['pid'] = this.PID;

    // Initiate StatusHandler
    this.SH = new StatusHandler(this);

    // Initiate the Call Handler
    let url = '/index.php?option=com_esa&format=json';
    //const CallHandlerClass = window.Hive.getCallHandler();
    this.CallHandler = window.Hive.getCallHandler(this, { silent : true, url : url });

    // Make the initial request
    this.CallHandler.postRequest('api.post',
      this.CallHandler.toFormData({
        request : "online.initiate",
        context : "com_esa.event.live",
        jform   : validData
      }),
      (success, responseData, message) => {
        if (success) {
          let html = responseData['html'] || { media : '', records : '' };
          let records = responseData['records'] || null;
          if (html.media && records) {

            // Set the records
            this.Records = records;

            // Insert the embed code
            this.utils.replaceElement(`[data-content="media"]`, html.media, (mediaHtml) => {

              // Create Listener
              this.initiatePlayer();

              // Start the Interval
              //const self = this;
              this.IH = new IntervalHandler(this.onIntervall.bind(this), { pulse : this.Options.logInterval, onInit : 'tik' });

              // Add global event listeners
              window.addEventListener("beforeunload", () => {
                this.onBeforeUnload();
              });

              // Add visibility listeners
              document.addEventListener("visibilitychange", () => {
                if (document.visibilityState === 'hidden') {
                  this.onDocumentHide();
                } else {
                  this.onDocumentShow();
                }
              });

              // Add click listener
              document.addEventListener("click", () => {
                this.onDocumentClick();
              });

              // Fire the DOM update event
              mediaHtml.dispatchEvent(new CustomEvent("joomla:updated", { bubbles : true, cancelable : true }));

              // Set active
              this.setActive();
            });
          } else {
            // Handle unsuccessful response
            this.setError({ message : message || 'GLOBAL_ERROR_RESPONSE_INVALID' });
          }
        } else {
          // Handle error
          this.setError({ message : message || 'GLOBAL_ERROR_UNDEFINED' });
        }
      }, true)
  }


  /**
   * CONTEXT
   */

  /**
   * validateContext
   * @return {null|{event_id:number, registration_id:number, content_item_id:number, content_id:number,content_type:string }}
   */
  validateContext() {
    let eventId = this.context['eventId'] || 0;
    let registrationId = this.context['registrationId'] || 0;
    let contentItemId = this.context['contentItemId'] || 0;
    let contentId = this.context['contentId'] || 0;
    let contentType = this.context['contentType'] || '';
    let accessLevel = this.context['accessLevel'] || 0;

    // Check mandatory fields
    if (!eventId || !contentItemId || !contentId || !contentType) {
      this.setError({ message : 'GLOBAL_ERROR_NO_INPUT' });

      return null;
    }

    // Simple access check
    if (accessLevel < 1 || (!registrationId && accessLevel < 5)) {
      this.setError({ message : 'GLOBAL_ERROR_UNAUTHORIZED' });

      return null;
    }

    return { event_id : eventId, registration_id : registrationId, content_item_id : contentItemId, content_id : contentId, content_type : contentType, };
  }

  /**
   * Check the current loaded content
   */
  checkContent() {
    this.utils.odb('Checking status.', this);

    // If the player is not ready, we can't access it
    // But maybe the event just didn't fire?
    if (!this.READY.Player) {
      this.utils.odb('Player not ready.', this);
    }

    if (!this.READY.Record) {
      this.utils.odb('Record not ready.', this);

      const { contentId : contentId } = this.context;
      this.initiateRecord(contentId);
    }

    // Already checking
    // if (this.Checking) return;
    // this.Checking = true;

    //// Get the video id
    //this.Player.getVideoId()
    //	.then((videoId) => {
    //		this.Checking = false;
    //
    //		// Initiate the (new) record
    //		this.initiateRecord(videoId);
    //	})
    //	.catch((error) => {
    //		this.Checking = false;
    //
    //		this.setWarning(error)
    //	});
  }


  /**
   * GENERAL EVENTS
   */

  /**
   * Load callback
   */
  onLoad() {
    this.loadingDisplay.add(this.Display, true).display();
  }

  /**
   * Ready callback
   */
  onReady() {
    this.loadingDisplay.add(this.Display, true).success();
  }

  /**
   * Error event
   */
  onError() {
    // Add body class
    document.body.classList.add('has-error');

    // Log if Error data is set
    const log = this.errorData ? Object.assign({}, this.State, { event : 'error', info : this.errorData }) :
      Object.assign({}, this.State, { event : 'error', info : '' });
    this.addLog(log);

    // Remove iframe
    if (this.Display) this.loadingDisplay.add(this.Display, true).error();
    if (this.iFrame) this.iFrame.remove();

    // Set controller status
    this.error();
  }

  /**
   * Sleeping Event
   */
  onSleep() {
    this.Sleeping = true;

    const log = Object.assign({}, this.State, { event : 'sleep' });
    this.addLog(log);

    //// Pause playback
    //if (this.PlayingState === 1) {
    //	// this.playerPause();
    //} else {
    //	this.PlayingState = 0;
    //}
  }

  /**
   * WakeUp Event
   */
  onWakeup() {
    this.Sleeping = false;

    let log = Object.assign({}, this.State, { event : "wakeup" });
    this.addLog(log);

    // Resume if paused
    //if (this.PlayingState === -1) {
    //	this.playerPlay();
    //} else {
    //	this.triggerPlaybackEvent();
    //}
  }


  /**
   * DOCUMENT/WINDOW EVENTS
   */

  /**
   * Sends 'unload' event, breaks chaining
   */
  onBeforeUnload() {
    if (!this.Logging) return

    this.triggerPlaybackEvent();

    const log = this.#buildLog(Object.assign({}, this.State, { event : "unload" }));
    this.CallHandler.sendRequest("api.post",
      this.CallHandler.toFormData({
        request : "online.close",
        context : "com_esa.event.live",
        log     : log
      }), 'POST'
    );

    //this.Logging = false;
  }

  /**
   * Send a last request before document gets closed
   */
  onDocumentHide() {
    if (!this.Logging) return;

    let log = Object.assign({}, this.State, { event : 'hide' });
    this.addLog(log);

    if (this.PlayingState !== 0) this.triggerPlaybackEvent();
  }

  /**
   * Resume playing when paused
   */
  onDocumentShow() {
    if (!this.Logging) return;

    let log = Object.assign({}, this.State, { event : 'show' });
    this.addLog(log);

    if (this.PlayingState !== 0) this.triggerPlaybackEvent();
  }

  /**
   * Check if user is still there
   */
  onDocumentClick() {
    if (!this.Logging) return;

    // Wakeup if set to sleep
    if (this.Sleeping) {
      this.setWakeup();

      return;
    }

    // Break the series
    // @todo think about a way to break series without conflict with an actual event
    if (this.PlayingState !== 0) {
      //let log = Object.assign({}, this.State, { event : 'click' });
      //this.addLog(log);
      //
      //let event = this.getState('event', null);
      //if (this.PlayingState === 1 || event === null || event === 'paused' || event === 'playing') {
      //	this.triggerPlaybackEvent();
      //}
    }

  }


  /**
   * EVENT TRIGGERS
   */

  /**
   * Set active
   */
  setActive() {
    // Set controller status
    this.active();
  }

  /**
   * Set warning
   * @param [input]
   */
  setWarning(input) {
    // Add body class
    document.body.classList.add('has-warning');

    // Bail if error isn't set
    if (!input) return;

    // Set message
    let message = 'GLOBAL_WARNING';
    if (typeof input === 'string') {
      message = input;
      input = {};
    } else if (input.message) {
      message = input.message;
    }

    // Display the warning
    this.utils.warning(message, input);
  }

  /**
   * Set error
   * @param input
   */
  setError(input) {

    // Set message
    let message = 'GLOBAL_ERROR_UNDEFINED';
    if (typeof input === 'string') {
      message = input;
      input = {};
    } else if (input.message) {
      message = input.message;
    }

    // Display the error
    this.utils.error(message, input, false);

    // Set the controller error
    this.errorData = message;

    // Trigger the event
    this.onError();
  }

  //noinspection JSUnusedLocalSymbols
  /**
   * Display a warning message, try to pause the video
   * @param {string|{}} [input]
   */
  setSleeping(input) {
    // Display the info
    //let message = 'Klicken Sie bitte auf diese Meldung.';
    //if (typeof input === 'string') {
    //	message = input;
    //} else if (input.message) {
    //	message = input.message;
    //}
    //this.utils.info(message);
    //
    //// Log the sleeping event
    this.onSleep();
  }

  //noinspection JSUnusedLocalSymbols
  /**
   * Display a warning message, try to pause the video
   * @param {string|{}} [input]
   */
  setWakeup(input) {
    // Log the sleeping event
    this.onWakeup();
  }

  /**
   * HANDLER EVENTS
   */

  /**
   * Handle the interval
   */
  onIntervall() {
    this.IH.tik();

    if (!this.READY.Player || !this.READY.Record) {
      this.checkContent();
    }

    // Trigger an update of the state
    if (this.READY.State && this.PlayingState !== 0) {
      this.triggerPlaybackEvent();
    }

    // Test connection if not logging
    if (!this.LogDate || ((new Date()).getTime() - this.LogDate) > this.Options.noLogTimeout * 1000) {
      this.testConnection();
    }
  }


  /**
   * PLAYER
   */

  /**
   * Create a new player instance
   */
  initiatePlayer() {

    // Add dom listener
    window.addEventListener('message', (event) => {
      if (/^https:\/\/(\w+\.)*vimeo(ws)?\.(com|dev)(:[0-9]+)?$/.test(event.origin)) {
        let data = event.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            this.utils.odb(`Error parsing event data: ${e}`, this);
            return;
          }
        }

        if ('event' in data) {

          let eventName = data.event;
          let eventData = data.data || null;

          // Set position, maybe set state to playing?
          if (eventName === 'timeupdate') {
            this.setState({ position : eventData.seconds });
            return;
          }

          // Playing
          if (eventName === 'play' || eventName === 'playing') {
            this.onPlaybackEvent(eventData, 'playing');
            this.PlayingState = 1;
            this.PausedBySystem = 0;
            return;
          }

          // Paused
          if (eventName === 'pause') {
            if (this.PlayingState > -1) {
              this.onPlaybackEvent(eventData, 'paused');
              this.PlayingState = -1;
            }
            this.PausedBySystem = 0;
            return;
          }

          // Player is ready
          if (eventName === 'ready') {
            this.utils.odb(`Player ready.`, this);
            this.READY.Player = true;
            return;
          }

          // Stream has ended
          if (eventName === 'ended') {
            this.onPlaybackEvent(eventData, 'ended');
            this.PlayingState = -2;
            this.PausedBySystem = 0;
            return;
          }

          if (eventName !== 'toastvisibilitychanged' && eventName !== 'controlbarvisibilitychanged') {
            this.utils.odb(data, this);
          }
        }
      }
    }, false)

    const { contentId : contentId } = this.context;
    this.initiateRecord(contentId);
  }

  /**
   * Update playback state (fires on pause, play, seek, ended...)
   * @param {object} data
   * @param {String} event
   */
  onPlaybackEvent(data, event) {
    if (!data || !event) return;

    // Get duration from state if we don't have any
    let duration = data.duration || 0;
    if (!duration || duration === Infinity) {
      duration = this.getState('duration', 0);
    }

    let position = data.seconds || data.position || 0;
    let triggered = data.triggered || 0;

    // Build update data
    let progress = this.utils.percentage(position, duration);
    let update = { position : position, duration : duration, progress : progress, triggered : triggered, event : event };

    this.setState(update);

    // Set playing state icon
    let state = 'idle';
    if (this.PlayingState > 0) {
      state = 'playing';
    } else if (this.PlayingState < 0) {
      state = 'paused';
    }
    this.SH.setStatus('state', state);
  }

  /**
   * Trigger an update
   * @param {String} [event]
   */
  triggerPlaybackEvent(event) {

    // Calculate the duration, check if we are on time
    const { eventTimes : eventTimes } = this.context;
    let sSince = ((new Date()).getTime() - this.startTime) / 1000;
    let sToStart = eventTimes[0] + sSince;
    let sToEnd = eventTimes[1] + sSince;
    let duration = Math.abs(sToEnd - sToStart);
    let position = this.getState('position', 0);

    if (!event) {
      if (this.PlayingState === 1) {
        event = "playing";
      } else if (this.PlayingState === -1) {
        event = "paused";
      } else {

        // let position = 0;
        if (sToStart < 0) {
          event = "waiting";
        } else if (sToEnd > 0) {
          event = "ended";
          // position = duration;
        } else { // Live
          event = "online";
          // this.PlayingState = 1;
          // position = sToStart;
        }
      }
    }

    this.onPlaybackEvent({ position : position, duration : duration, triggered : 1 }, event);
  }

  /**
   * RECORDS
   */

  /**
   * Initiate record / ing
   * @param {Number} contentId
   */
  initiateRecord(contentId) {

    // If we made it this far, player must be ready
    //if (!this.READY.Player) {
    //	this.utils.odb(`Player is ready.`, this);
    //	this.READY.Player = true;
    //}

    // Check if content is already active
    let contentKey = `${this.ContentType}.${contentId}`;
    if (this.ContentKey === contentKey) {
      this.utils.odb(`Record (${contentKey}) already initiated.`, this);
      this.READY.Record = true;
      return;
    }

    // Initiate content
    this.utils.odb(`Initiate record (${contentKey}).`, this);

    // Reset the state and ready markers
    this.State = {};
    this.READY.Record = false;
    this.READY.State = false;
    this.PlayingState = 0;

    // Get the record
    const CurrentRecord = this.getRecord(contentKey);
    if (!CurrentRecord) {
      this.setError({ message : 'Fehler bei der Initialisierung, bitte laden Sie die Seite neu.' })
      return;
    }

    // Check if the record has an id
    let recordId = CurrentRecord.id || 0;
    if (!recordId) {
      this.RecordId = 0;
      this.Logging = false;
      this.utils.odb(`Record (${contentKey}) has no ID, assuming simulation and continue.`, this);
    } else {
      this.RecordId = recordId;
      this.Logging = true;
      this.utils.odb(`Record (${contentKey}) has the ID ${recordId}.`, this);
    }

    // Set the contentKey, remove checking marker and set content to ready
    this.ContentKey = contentKey;

    // Record is ready
    this.utils.odb(`Record (${contentKey}) is ready.`, this);
    this.READY.Record = true;

    // Initiate the state
    this.initiateState(contentId);

    // Remove loading display
    this.onReady();
  }

  /**
   * Get the records
   * @return {{}}
   */
  getRecords() {
    if (!this.Records) {
      this.utils.odb('Loading records from context.', this);
      const { records : Records } = this.context;
      this.Records = Records || null;
    }
    return this.Records;
  }

  /**
   * Get a record
   * @param {string} key
   * @return {{}|null}
   */
  getRecord(key) {
    const Records = this.getRecords();
    return Records[key] || null;
  }

  /**
   * Update of the record
   * @param {number} [recordId]
   * @deprecated
   */
  updateRecord(recordId) {
    recordId = recordId || this.RecordId;

    this.CallHandler.getRequest('api.get',
      {
        request   : "online.record.update",
        context   : "com_esa.event.live",
        record_id : recordId,
        pid       : this.PID,
      },
      (success, responseData) => {
        if (success && responseData.record) {
          this.updateDisplay(responseData.record);
        }
      },
      true)
  }

  /**
   * Update html
   * @param {object} recordData
   * @param {string} [recordHtml]
   */
  updateDisplay(recordData, recordHtml) {

  }


  /**
   * STATE
   */

  /**
   * Reset and rebuild the state for the current video
   * @param {Number} contentId
   */
  initiateState(contentId) {
    this.utils.odb("Initiate state.", this);

    // Set the new ID
    this.setState({ contentId : contentId });

    // Trigger the initiated event
    this.triggerPlaybackEvent('initiated');

    // And playback state event right afterward
    this.triggerPlaybackEvent();

    // Set state to ready
    this.utils.odb('State is ready.', this);
    this.READY.State = true;
  }

  /**
   * Set and log the current state
   * @param {object} data
   */
  setState(data) {
    // Check player & record
    if (!this.READY.Player || !this.READY.Record) {
      this.checkContent();
    }

    // Update the state
    Object.assign(this.State, data);
    // this.utils.odb(this.State, this);

    // Create a log entry if data contains an event
    let event = data.event ? data.event : null;
    if (event) this.addLog(this.State);
  }

  /**
   * Get a variable from state
   * @param {string} name
   * @param {null|*} def
   * @return {null|*}
   */
  getState(name, def = null) {
    const state = this.State;
    if (typeof state[name] !== 'undefined' && state[name] !== null) {
      return state[name];
    }

    return def;
  }

  /**
   * Set state value if not defined
   * @param {string} name
   * @param value
   */
  defState(name, value) {
    if (this.getState(name)) return;

    let defData = {};
    defData[name] = value;
    this.setState(defData);
  }


  /**
   * LOGGING
   */

  /**
   * Log a state set
   * @param data
   */
  addLog(data = {}) {
    if (!this.Logging) return;

    // Validate / filter the data
    if (!this.#validateLog(data)) return;

    // Build the log data
    let log = this.#buildLog(data);

    // If sleeping, only errors, wakeup and sleep events will get through
    if (this.Sleeping) {
      this.utils.odb(`Sleeping, not logging event ${log.event}.`, this);
      if (log.event !== 'error' && log.event !== 'wakeup' && log.event !== 'sleep') return;
    }

    // Add data to call stack
    this.LogQueue.push(log);

    // Start calling
    this.#saveLog();
  }

  /**
   * Build the log data
   * @param {{}} data
   * @return {{}}
   */
  #buildLog(data) {
    const logData = {};
    logData.record_id = this.RecordId;
    logData.pid = this.PID;
    logData.event = data.event;
    logData.info = data.info || '';
    logData.created = this.utils.getISODate();
    logData.data = Object.assign({}, data);

    return logData;
  }

  /**
   * Check if a state is worth saving
   * @param {{}} data
   * @return {boolean}
   */
  #validateLog(data = {}) {
    // Record ID must be set.
    if (!this.Logging || !this.RecordId) return false;

    // An error may pass without videoId or duration
    return !(!data.contentId && data.event !== 'error');
  }

  /**
   * Save log data
   */
  #saveLog() {
    // Return if nothing is to be saved
    if (!this.LogQueue.length) {
      this.Calling = false;

      return;
    }

    // Return if already calling
    if (this.Calling) return;
    this.Calling = true;

    // Get the next log data
    const log = this.LogQueue.shift();
    this.CallHandler.postRequest('api.post',
      this.CallHandler.toFormData({
        request : "online.log",
        context : "com_esa.event.live",
        log     : log
      }),
      (success, responseData, message) => {
        this.Calling = false;

        // Set date and data from response
        this.LogDate = (new Date()).getTime();
        this.LogData = { success : success, response : responseData, message : message };

        // Set connection and log status
        this.SH.setStatus('log', (success ? 'success' : 'fail'));
        this.SH.setStatus('connection', (success ? 'connected' : 'disconnected'));

        // Schedule next call
        let timeOut = success ? this.Options.logQueueTimeout * 1000 : (this.Options.logInterval / 3) * 1000;
        this.utils.addTimer(() => {
          this.#saveLog()
        }, timeOut, 'save_log');

        // Check the response for additional commands
        this.onResponse(success, responseData);
      },
      true)
  }


  /**
   * RESPONSE INTERFACE
   */

  /**
   * Check response for commands
   *
   * @param {boolean} success
   * @param {object|null} responseData
   */
  onResponse(success, responseData) {
    responseData = responseData || null;

    if (!responseData) {
      //this.setError({ message : 'Verbindung zum Server verloren, bitte laden Sie die Seite neu.' });
      return;
    }

    // Check for commands in the request
    let commands = responseData.hasOwnProperty('cmd') && typeof responseData.cmd === 'object' ? responseData.cmd : null;
    if (!commands || typeof commands !== 'object') return;

    // Options update
    if (commands.hasOwnProperty('doOptions') && commands.doOptions !== undefined) {
      Object.assign(this.Options, commands.doOptions)
      this.IH && this.IH.adjust(this.Options.logInterval);
    }

    // Log
    if (commands.hasOwnProperty('doLog')) {
      let data = commands.doLog.data || {};
      let log = Object.assign({}, this.State, data)
      this.addLog(log);
    }

    // Set sleeping
    if (commands.hasOwnProperty('doSetSleep')) {
      this.setSleeping(commands.doSetSleep);
    }

    // Trigger an error
    if (commands.hasOwnProperty('doSetError') && commands.doSetError !== undefined) {
      this.setError(commands.doSetError);
    }

    // Show message
    if (commands.hasOwnProperty('doMessage') && commands.doMessage !== undefined) {
      let message = commands.doMessage.message;
      let type = commands.doMessage.type || 'info';
      this.utils.displayMessage(message, type);
    }

    // Update the display
    if (commands.hasOwnProperty('doUpdateDisplay') && commands.doUpdateDisplay !== undefined) {
      if (Array.isArray(commands.doUpdateDisplay)) {
        this.updateDisplay(...commands.doUpdateDisplay);
      } else {
        this.updateDisplay(commands.doUpdateDisplay);
      }
    }

    // Update context
    if (commands.hasOwnProperty('doReloadContext') && commands.doReloadContext !== undefined) {
      Object.assign(this.context, commands.doReloadContext);
      let contentId = this.context.contentId;
      this.ContentKey = '';
      this.initiateRecord(contentId);
    }

    // Update context
    if (commands.hasOwnProperty('doUpdateContext') && commands.doUpdateContext !== undefined) {
      Object.assign(this.context, commands.doUpdateContext);
    }

    // Force a state
    if (commands.hasOwnProperty('doSetState') && commands.doSetState !== undefined) {
      this.setState(commands.doSetState);
    }
  }


  /**
   * DEBUGGING
   */

  /**
   * Test the connection to the server
   */
  testConnection() {
    this.CallHandler.getRequest('api.get',
      { request : 'connected' },
      (success) => {
        this.SH.setStatus('connection', (success ? 'connected' : 'disconnected'));
      },
      true)
  }
}

export default LiveEventController
